export const publicSite = "https://cacherivertelephone.com";
export const customerSite = "https://portal.cacherivertelephone.com";
export const staffSite = "https://admin.cacherivertelephone.com";
export function isCacheRiverHost(host: string) {
  return [
    "cacherivertelephone.com",
    "www.cacherivertelephone.com",
    "portal.cacherivertelephone.com",
    "admin.cacherivertelephone.com",
  ].includes(host);
}
export function serviceLink(path: string, host: string) {
  if (!isCacheRiverHost(host) && !host.endsWith(".chatgpt.site")) return path;
  const pathname = path.split(/[?#]/)[0]!;
  return (
    (pathname === "/admin" || pathname.startsWith("/admin/")
      ? staffSite
      : pathname === "/register" ||
          pathname === "/" ||
          pathname === "/privacy" ||
          pathname === "/website-use"
        ? publicSite
        : customerSite) + path
  );
}
